<template>
  <info-dialog v-model="modelValue">
    <template #title>
      <span>
        A dose deve ser prescrita de acordo com o peso do paciente e o nível sérico de IgE medido antes do início do
        tratamento. As doses estão nas Tabelas 1 e 2 e a quantidade de seringas de 75 mg e 150 mg aplicar, na Tabela 3.
      </span>
    </template>

    <div class="d-flex flex-column gap-6 pt-2">
      <figure>
        <img src="assets/attendance-form/medicine-prescription/omalizumab/table-1.png" class="dialog-img" />
        <figcaption class="font-size-14">
          Tabela 1 - Dose de Omalizumabe administrada por injeção subcutânea a cada 4 semanas
        </figcaption>
      </figure>
      <figure>
        <img src="assets/attendance-form/medicine-prescription/omalizumab/table-2.png" class="dialog-img" />
        <figcaption class="font-size-14">
          Tabela 2 - Dose de Omalizumabe administrada por injeção subcutânea a cada 2 semanas.
        </figcaption>
      </figure>
      <figure>
        <img src="assets/attendance-form/medicine-prescription/omalizumab/table-3.png" class="dialog-img" />
        <figcaption class="font-size-14">
          Tabela 3 - Conversão de dose para número de seringas preenchidas, número de injeções e volume total de injeção
          para cada administração
        </figcaption>
      </figure>
    </div>
  </info-dialog>
</template>

<script>
import { ComputedOptions } from 'vue'
import InfoDialog from '@/components/NewAttendanceForm/FormNodes/InfoDialogs/InfoDialog.vue'

export default {
  components: { InfoDialog },
  name: 'OmalizumabDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style scoped>
.dialog-img {
  max-width: 100%;
}
</style>
